<div class="ngb-toasts" style="position: absolute; z-index: 0; right: 0; top: 0; margin: .5em;">
	@if (messages?.isInsPointOutBoxAP) {
	<message [text]="labels().MESSAGES_COMPONENT_INS_POINT_OUT_BOX_AP" />
	}
	@if (messages?.isInsPointOutBoxLT) {
	<message [text]="labels().MESSAGES_COMPONENT_INS_POINT_OUT_BOX_LT" />
	}
	@if (messages?.isScrewNearOstAP) {
	<message [text]="labels().MESSAGES_COMPONENT_SCREW_NEAR_OST_AP" />
	}
</div>